import React, {Component} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Table,
  Card,
  CardHeader,
  CardBody
} from 'reactstrap'
import {Link} from 'react-router-dom'
import {withRouter} from 'react-router'
import {Line} from 'react-chartjs-2'
import 'chartjs-plugin-zoom'
import 'chartjs-plugin-annotation'
// import CloseIcon from 'react-icons/lib/md/close'


import {getStructureById} from '../../modules/structures'
import BaderLine from './baderLine'
import MadelungConstants from './madelungConstants'
import APIRequest from '../../helpers/APIRequest'

import LoadingIcon from 'react-icons/lib/fa/spinner'
// import CheckIcon from 'react-icons/lib/fa/check'

import {Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap'
import DownloadIcon from 'react-icons/lib/fa/download'
import ExpandIcon from 'react-icons/lib/fa/expand'
import MinusIcon from 'react-icons/lib/fa/minus-square'
import PlusIcon from 'react-icons/lib/fa/plus-square'

import {getFormula} from '../../helpers/lib'

import './structure.css'

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

const colors = [brandSuccess, brandWarning, brandDanger, brandInfo, brandPrimary]

const round10 = (number = 0, exp = 0) => {
  return number.toFixed(exp);
}

const Percent = (props) => <span>
  {(props.number * 100).toFixed(props.exp)}
  %
</span>;

// convert Hex to RGBA
function convertHex(hex, opacity) {
  hex = hex.replace('#', '');
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);

  var result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
  return result;
}

class Structure extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      bader: false,
      madelung: false,
      openedPdos: true,
      openedXrd: true,
      openedBader: true,
      openedMadelung: true,
      openedBeyong: false,
      dropdownOpen: false
    };
    this.toggle = this.toggle.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  toggleDropdown() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }
  componentWillMount() {
    if (this.props) {
      const getStructureById = this.props.getStructureById;
      getStructureById(this.props.structureId);
      this.interval = setInterval(function() {
        if (this.props && this.props.structure) {
          getStructureById(this.props.structureId);
        }
      }.bind(this), 10000);
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps._id !== this.props._id) {
      this.props.getStructureById(this.props.structure._id);
    }
    const structure = this.props.structure;
    if (this.jmolDiv && this.jmolId !== structure._id) {
      const div = document.getElementById('appletplace1');
      this.jmolId = structure._id;
      const jmolDiv = this.jmolDiv;
      APIRequest.get(`structures/${this.props.structure.relaxedStructure._id}/cif`, {responseType: 'blob'}).then(res => {
        const reader = new FileReader();
        reader.onloadend = function(evt) {
          if (evt.target.readyState === FileReader.DONE) {
            window.fileName = `${structure.name}.cif`;
            window.buffer = evt.target.result;
            document.getElementById('loadCif').click()
            setTimeout(() => jmolDiv.appendChild(div), 1000);
            //Jmol._setData(null, `${structure.name}.cif`, `${structure.name}.cif`, evt.target.result, null, myJmol);
          }
        };
        try {
          reader.readAsArrayBuffer(res.data);
        } catch (e) {
          alert("You must select a file first.");
        }
      }).catch((error) => {
        console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
      });

    }

  }

  componentWillUnmount() {
    clearInterval(this.interval);

    const div = document.getElementById('appletplace1');
    const hideJmol = document.getElementById('hideJmol');
    hideJmol.appendChild(div);
  }

  checkRelaxation() {
    const that = this;
    that.getRelaxedStructure();
    this.interval = setInterval(function() {
      that.getRelaxedStructure();
    }, 10000);
  }

  checkPotential() {
    const that = this;
    that.getGlobalPotential();
    this.interval2 = setInterval(function() {
      that.getGlobalPotential();
    }, 10000);
  }

  getRelaxedStructure() {
    APIRequest.get(`structures/${this.props.structure._id}/relaxedStructure`).then(res => {
      console.log('getRelaxedStructure', res);
    }).catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
    }).then(() => this.props.getStructureById(this.props.structure._id));
  }

  getDelithiedStructure() {
    APIRequest.get(`structures/${this.props.structure._id}/delithiedStructure`).then(res => {
      console.log('getDelithiedStructure', res);
    }).catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
    });
  }

  getGlobalPotential() {
    APIRequest.get(`structures/${this.props.structure._id}/globalPotential`).then(res => {
      console.log('getGlobalPotential', res);
    }).catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
    }).then(() => this.props.getStructureById(this.props.structure._id));
  }

  getRelaxationAnalyser() {
    APIRequest.get(`structures/${this.props.structure._id}/relaxationAnalyser`).then(res => {
      this.setState({relaxationAnalyser: res.data});
    })/*.catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
    });*/
  }

  getPdos() {
    APIRequest.get(`structures/${this.props.structure._id}/pdos`).then(res => {
      const x = res.data[0];
      const tdos = res.data[1].map((y, index) => ({'x': x[index], 'y': y}));
      const data = {
        //labels: res.data[0],
        datasets: [
          {
            data: tdos,
            label: 'tdos',
            backgroundColor: convertHex(brandInfo, 10),
            borderColor: brandInfo,
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            showLine: true
          }
        ]
      }
      const pdos = res.data[2]
      Object.keys(pdos).forEach((el, index) => {
        let table = pdos[el].map((y, index) => ({'x': x[index], 'y': y}));
        data.datasets = [
          ...data.datasets, {
            data: table,
            label: el,
            backgroundColor: 'transparent',
            borderColor: colors[index],
            pointHoverBackgroundColor: '#fff',
            borderWidth: 1,
            showLine: true

          }
        ]
      })
      this.setState({tdos: data, tdosInverse: false});
      this.pdos.chartInstance.resetZoom();
    }).catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
    });
  }

  getPdosInversed() {
    APIRequest.get(`structures/${this.props.structure._id}/pdos`).then(res => {
      const x = res.data[0];
      const tdos = res.data[1].map((y, index) => ({'y': x[index], 'x': y}));
      const data = {
        //labels: res.data[0],
        datasets: [
          {
            data: tdos,
            label: 'tdos',
            backgroundColor: convertHex(brandInfo, 10),
            borderColor: brandInfo,
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            showLine: true
          }
        ]
      }
      const pdos = res.data[2]
      Object.keys(pdos).forEach((el, index) => {
        let table = pdos[el].map((y, index) => ({'y': x[index], 'x': y}));
        data.datasets = [
          ...data.datasets, {
            data: table,
            label: el,
            backgroundColor: 'transparent',
            borderColor: colors[index],
            pointHoverBackgroundColor: '#fff',
            borderWidth: 1,
            showLine: true

          }
        ]
      })
      this.setState({tdos: data, tdosInverse: true});
      this.pdos.chartInstance.resetZoom();
    }).catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
    });
  }

  getXRD(event) {
    event.preventDefault()
    const wavelength = event.target.wavelength.value.trim();
    APIRequest.get(`structures/${this.props.structure._id}/xrd`, {
      params: {
        wavelength: wavelength
      }
    }).then(res => {

      const data = [];
      res.data[0]['x'].forEach((value, index) => {
        data.push({
          'x': value - 0.0000001,
          'y': 0
        })
        data.push({'x': value, 'y': res.data[0]['y'][index]
        })
        data.push({
          'x': value + 0.0000001,
          'y': 0
        })
      });

      const scatterData = {
        datasets: [
          {
            borderColor: brandInfo,
            label: 'XRD',
            borderWidth: 1,
            data
          }
        ]
      }

      this.setState({xrd: scatterData});
    }).catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
    });
  }

  getCif() {
    APIRequest.get(`structures/${this.props.structure.relaxedStructure._id}/cif`, {responseType: 'blob'}).then(res => {
      const objectURL = window.URL.createObjectURL(res.data);
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = objectURL;
      a.download = `${this.props.structure.name}.cif`;
      a.click();
      window.URL.revokeObjectURL(objectURL);
    }).catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
    });
  }

  downloadTdos() {
    APIRequest.get(`structures/${this.props.structure._id}/downloadTdos`, {responseType: 'blob'}).then(res => {
      const objectURL = window.URL.createObjectURL(res.data);
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = objectURL;
      a.download = `${this.props.structure.name}_tdos`;
      a.click();
      window.URL.revokeObjectURL(objectURL);
    }).catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
    });
  }

  downloadPdos() {
    APIRequest.get(`structures/${this.props.structure._id}/downloadPdos`, {responseType: 'blob'}).then(res => {
      const objectURL = window.URL.createObjectURL(res.data);
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = objectURL;
      a.download = `${this.props.structure.name}_pdos`;
      a.click();
      window.URL.revokeObjectURL(objectURL);
    }).catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
    });
  }

  exportPdos() {
    const dataURL = this.pdos.chartInstance.canvas.toDataURL();
    var a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = dataURL;
    a.download = `${this.props.structure.name}_pdos_graph`;
    a.click();
  }

  resetPdosZoom() {
    this.pdos.resetZoom();
  }

  exportXRD() {
    const dataURL = this.xrd.chartInstance.canvas.toDataURL();
    var a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = dataURL;
    a.download = `${this.props.structure.name}_XRD_graph`;
    a.click();
  }

  getSymmetrizedCif() {
    APIRequest.get(`structures/${this.props.structure.relaxedStructure._id}/symmetrizedcif`, {responseType: 'blob'}).then(res => {
      const objectURL = window.URL.createObjectURL(res.data);
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = objectURL;
      a.download = `${this.props.structure.name}_sym.cif`;
      a.click();
      window.URL.revokeObjectURL(objectURL);
    }).catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
    });
  }

  supercell() {
    APIRequest.get(`structures/${this.props.structure.relaxedStructure._id}/supercell?vector=[2,2,2]`).then(res => {
      console.log('supercell', res);
    }).catch((error) => {
      console.log('Il y a eu un problème avec l\'opération fetch: ' + error.message);
    }).then(() => this.props.getStructureById(this.props.structure._id));
  }

  toggleCifMenu() {
    this.cifMenu.classList.contains('show')
      ? this.cifMenu.classList.remove('show')
      : this.cifMenu.classList.add('show')
  }

  render() {
    const {
      structure,
      project = {}
    } = this.props;
    if (structure && structure.relaxedStructure) {
      return (
        <div>
          <ol className="breadcrumb bg-gray-600 border-bottom-0 align-items-center">
            <li className="breadcrumb-item">
              <Link to="/projects">Projects</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to={`/projects/${project._id}`}>{getFormula(project.name)}</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to={`/projects/${project._id}`}>structures</Link>
            </li>
            <li className="breadcrumb-item active">{getFormula(structure.name)}</li>

          </ol>
          <Container fluid={true}>
            {
                structure.relaxedStructure && !structure.relaxedStructure.converged
                  ? <p className="alert alert-warning">The structure is not converged !</p>
                  : null
            }

            <Row>
              <Col className="col col-md-4 mb-4">
                <Card className="h-100 mb-0">
                  <CardHeader className="card-header-actions">
                    <Row className="no-gutters align-items-strech">
                      <Col className="col-auto mr-auto card-header-action"><h5 className="m-0">QCATS viewer</h5></Col>
                      <Col className="col-auto border-left">
                        <div className="btn-group vertical-stretch">
                          <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown} className="vertical-stretch">
                            <DropdownToggle className="btn-light mt-0 card-header-action">
                              <DownloadIcon style={{
                                cursor: 'pointer'
                              }}/>
                            </DropdownToggle>
                            <DropdownMenu right={true}>
                              <DropdownItem onClick={this.getCif.bind(this)}>Download Cif</DropdownItem>
                              <DropdownItem onClick={this.getSymmetrizedCif.bind(this)}>Download symetrized Cif</DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </div>
                      </Col>
                      <Col className="col-auto border-left">
                        <Link className="btn btn-light mt-0 card-header-action vertical-center" to={`/projects/${project._id}/structures/${structure._id}/jmol`}><ExpandIcon/></Link>
                      </Col>
                    </Row>
                  </CardHeader>
                  <CardBody className="p-0 text-center" style={{ display: 'flex', alignItems: 'center', overflow: 'hidden'}}>
                    <div ref={(jmolDiv) => {
                      this.jmolDiv = jmolDiv;
                    }} style={{
                      position: 'relative',
                      display: 'flex',
                      height: '270px',
                      width: '270px',
                      margin: 'auto',
                      zIndex: 1
                    }}><LoadingIcon className="fa-spin m-auto text-gray-200" size="96"/></div>
                  </CardBody>
                </Card>
              </Col>
              <Col className="col col-md-4 mb-4">
                <Card className="h-100 mb-0">
                  <CardHeader className="strong"><h5 className="m-0">Structure details</h5>
                  </CardHeader>
                  <CardBody>
                    <Table size="sm" className="table no-border">
                      <tbody>
                        <tr>
                          <td className="text-muted">Space group:</td>
                          <td><b>{
                            structure.relaxedStructure.spaceGroupInfo
                              ? <span>{structure.relaxedStructure.spaceGroupInfo[0]}
                                ({structure.relaxedStructure.spaceGroupInfo[1]})</span>
                              : null
                          }</b></td>
                        </tr>
                        <tr>
                          <td className="text-muted">Unit cell volume:</td>
                          <td><b>{round10(structure.relaxedStructure.volume, 2)} Å<sup>3</sup>
                          </b>
                          </td>
                        </tr>
                        <tr>
                          <td className="text-muted">Factor Z:</td>
                          <td><b>{structure.relaxedStructure.factor}</b></td>
                        </tr>
                        <tr>
                          <td className="text-muted">Formula:</td>
                          <td><b>{structure.relaxedStructure.formula}</b>
                          </td>
                        </tr>
                        <tr>
                          <td className="text-muted">Wyckoff:</td>
                          <td><b>{
                            structure.relaxedStructure.wyckoffs
                              ? structure.relaxedStructure.wyckoffs.map((wyckoff, index) => <span key={index}>{wyckoff} </span>)
                              : null
                          }</b>
                          </td>
                        </tr>
                        <tr>
                          <td className="text-muted">Total Energy:</td>
                          <td><b>{ Number(structure.relaxedStructure.finalEnergy / structure.relaxedStructure.atomicNumbers.length).toFixed(4) } eV/at</b></td>
                        </tr>
                      </tbody>
                    </Table>
                  </CardBody>
                </Card>
              </Col>
              <Col className="col-4 mb-4 col">
                <Card className="h-100 mb-0">
                  <CardHeader><h5 className="m-0">Calculation details</h5></CardHeader>
                  <CardBody>
                    <Table size="sm" className="table no-border">
                      <tbody>
                        <tr>
                          <td className="text-muted">DFT code used :</td>
                          <td><b>VASP</b></td>
                        </tr>
                        <tr>
                          <td className="text-muted">EDIFFG :</td>
                          <td><b>{structure.relaxationEdiffg}</b></td>
                        </tr>
                        {/* <tr>
                          <td className="text-muted">XC functional used :</td>
                          <td><b>xxx</b></td>
                          </tr>
                          <tr>
                          <td className="text-muted">U parameter (eV) :</td>
                          <td><b>xxx</b></td>
                          </tr>
                          <tr>
                          <td className="text-muted">Energy cut-off (eV) :</td>
                          <td><b>xxx</b></td>
                          </tr>
                          <tr>
                          <td className="text-muted">Kpoint density (KPT/Å-1) :</td>
                          <td><b>xxx</b></td>
                          </tr>
                          <tr>
                          <td className="text-muted">Accuracy :</td>
                          <td><b>xxx</b></td>
                          </tr>
                          <tr>
                          <td className="text-muted">Papers to be cited :</td>
                          <td><b>xxx</b></td>
                        </tr> */}
                      </tbody>
                    </Table>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col className="col col-md-4 mb-4">
                <div className="card h-100 mb-0">
                  <div className="card-header">
                    <h5 className="m-0">Initial Lattice parameters</h5>
                  </div>
                  <div className="card-body">

                    <p className="row">
                      <label className="col-6 text-muted pr-1">Space group:</label>&nbsp; {
                        structure.spaceGroupInfo
                          ? <b className="col text-dark pl-1">{structure.spaceGroupInfo[0]}
                            ({structure.spaceGroupInfo[1]})</b>
                          : null
                      }</p>

                    <p className="row">
                      <label className="col-6 text-muted pr-1">Volume:</label>&nbsp;
                      <b className="col text-dark pl-1">{Number(structure.volume).toFixed(2)}&nbsp;
                        A<sup>3</sup>
                      </b>
                    </p>

                    <table className="table table-sm text-right no-margin">
                      {
                        structure.lattice
                          ? <tbody>
                            <tr>
                              <th className="text-muted">a</th>
                              <td className="text-dark">{round10(structure.lattice.abc.a, 4)}
                              Å</td>
                              <td className="separator"><div/></td>
                              <th className="text-muted">α</th>
                              <td className="text-dark">{round10(structure.lattice.angles.α, 2)}
                              °</td>
                            </tr>
                            <tr>
                              <th className="text-muted">b</th>
                              <td className="text-dark padding-right">{round10(structure.lattice.abc.b, 4)}
                              Å</td>
                              <td className="separator"><div/></td>
                              <th className="text-muted">β</th>
                              <td className="text-dark">{round10(structure.lattice.angles.β, 2)}
                              °</td>
                            </tr>
                            <tr>
                              <th className="text-muted">c</th>
                              <td className="text-dark padding-right">{round10(structure.lattice.abc.c, 4)}
                              Å</td>
                              <td className="separator"><div/></td>
                              <th className="text-muted">γ</th>
                              <td className="text-dark">{round10(structure.lattice.angles.γ, 2)}
                              °</td>
                            </tr>
                          </tbody>
                          : null
                      }
                    </table>
                  </div>
                </div>
              </Col>
              <Col className="col col-md-4 mb-4">
                <div className="card h-100 mb-0">
                  <div className="card-header">
                    <h5 className="m-0">Relaxed Lattice parameters</h5>
                  </div>
                  <div className="card-body">

                    <p className="row">
                      <label className="col-6 text-muted pr-1">Space group:</label>&nbsp; {
                        structure.relaxedStructure.spaceGroupInfo
                          ? <b className="col text-dark pl-1">{structure.relaxedStructure.spaceGroupInfo[0]}
                            ({structure.relaxedStructure.spaceGroupInfo[1]})</b>
                          : null
                      }</p>

                    <p className="row">
                      <label className="col-6 text-muted pr-1">Volume:</label>&nbsp;
                      <b className="col text-dark pl-1">{Number(structure.relaxedStructure.volume).toFixed(2)}&nbsp;
                        A<sup>3</sup>
                      </b>
                    </p>

                    <table className="table table-sm text-right no-margin">
                      {
                        structure.relaxedStructure.lattice
                          ? <tbody>
                            <tr>
                              <th className="text-muted">a</th>
                              <td className="text-dark">{round10(structure.relaxedStructure.lattice.abc.a, 4)}
                              Å</td>
                              <td className="separator"><div/></td>
                              <th className="text-muted">α</th>
                              <td className="text-dark">{round10(structure.relaxedStructure.lattice.angles.α, 2)}
                              °</td>
                            </tr>
                            <tr>
                              <th className="text-muted">b</th>
                              <td className="text-dark padding-right">{round10(structure.relaxedStructure.lattice.abc.b, 4)}
                              Å</td>
                              <td className="separator"><div/></td>
                              <th className="text-muted">β</th>
                              <td className="text-dark">{round10(structure.relaxedStructure.lattice.angles.β, 2)}
                              °</td>
                            </tr>
                            <tr>
                              <th className="text-muted">c</th>
                              <td className="text-dark padding-right">{round10(structure.relaxedStructure.lattice.abc.c, 4)}
                              Å</td>
                              <td className="separator"><div/></td>
                              <th className="text-muted">γ</th>
                              <td className="text-dark">{round10(structure.relaxedStructure.lattice.angles.γ, 2)}
                              °</td>
                            </tr>
                          </tbody>
                          : null
                      }
                    </table>
                  </div>
                </div>
              </Col>
              {
                structure.relaxedStructure
                  ? <Col className="col-4 mb-4">
                    <div className="card h-100 mb-0">
                      <div className="card-header">
                        <Row>
                          <Col className="col-auto mr-auto"><h5 className="m-0">Relaxation analyser</h5></Col>
                          <Col className="col-auto"></Col>
                        </Row>
                      </div>
                      <div className="card-body row align-items-center">
                        {
                          this.state && this.state.relaxationAnalyser
                            ? <div className="col">
                              {/*<div className="col-7">
                                <h6>Bond distance:</h6>

                                <table className="table table-sm text-right no-margin">
                                <tbody>
                                <tr><th></th></tr>
                                </tbody>
                                </table>
                                </div>*/
                              }
                              <p className="row">
                                <label className="col-6 text-muted pr-1">Volume change:</label>&nbsp;
                                <b className="col text-dark pl-1"><Percent number={this.state.relaxationAnalyser.dvol} exp={2}/></b>
                              </p>

                              <table className="table table-sm mw-200 mb-0">
                                <tbody>
                                  <tr>
                                    <th className="text-muted">
                                      δa/a
                                    </th>
                                    <td className="text-dark"><Percent number={this.state.relaxationAnalyser.dlat['a']} exp={2}/></td>
                                  </tr>
                                  <tr>
                                    <th className="text-muted">
                                      δb/b
                                    </th>
                                    <td className="text-dark"><Percent number={this.state.relaxationAnalyser.dlat['b']} exp={2}/></td>
                                  </tr>
                                  <tr>
                                    <th className="text-muted">
                                      δc/c
                                    </th>
                                    <td className="text-dark"><Percent number={this.state.relaxationAnalyser.dlat['c']} exp={2}/></td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            : <div className="col text-center">
                              <button className="btn btn-primary" onClick={this.getRelaxationAnalyser.bind(this)}>Get relaxation analyser</button>
                            </div>
                        }
                      </div>
                    </div>
                  </Col>
                  : null
              }
              {
                structure.relaxedStructure && structure.relaxedStructure.converged
                  ? <Col className="col-6 mb-4">
                    <div className="card h-100 mb-0">
                      <div className="card-header">
                        <Row>
                          <Col className="col-auto mr-auto"><h5 className="m-0">Density of states (DOS)</h5></Col>
                          <Col className="col-auto">
                            <a className="text-muted" onClick={() => this.setState({
                              openedPdos: !this.state.openedPdos
                            })}>
                              {
                                this.state.openedPdos
                                  ? <MinusIcon/>
                                  : <PlusIcon/>
                              }
                            </a>
                          </Col>
                        </Row>
                      </div>
                      {
                        this.state.openedPdos
                          ? <div className="card-body row align-items-center">
                            {
                              this.state && this.state.tdos
                                ? <div className="col">
                                  <Line ref={(pdos) => {
                                    this.pdos = pdos;
                                  }} data={this.state.tdos} options={{
                                    // maintainAspectRatio: false,
                                    legend: {
                                      // display: false
                                    },
                                    scales: {
                                      [
                                      !this.state.tdosInverse
                                        ? 'xAxes'
                                        : 'yAxes'
                                      ]: [
                                      {
                                        type: 'linear',
                                        gridLines: {
                                          // drawOnChartArea: false,
                                        },
                                        scaleLabel: {
                                          display: true,
                                          labelString: 'Energy (V)',
                                          fontSize: 14,
                                          fontStyle: 'bold'
                                        },
                                        ticks: {
                                          fontSize: 14,
                                          fontStyle: 'bold'
                                        }
                                      }
                                      ],
                                      [
                                      !this.state.tdosInverse
                                        ? 'yAxes'
                                        : 'xAxes'
                                      ]: [
                                      {
                                        scaleLabel: {
                                          display: false
                                        },
                                        ticks: {
                                          fontSize: 14,
                                          fontStyle: 'bold'
                                          // beginAtZero: true,
                                          // maxTicksLimit: 5,
                                          // stepSize: Math.ceil(250 / 5),
                                          // max: 250
                                        }
                                      }
                                      ]
                                    },
                                    elements: {
                                      point: {
                                        radius: 0,
                                        hitRadius: 10,
                                        hoverRadius: 4,
                                        hoverBorderWidth: 3
                                      }
                                    },
                                    zoom: {
                                      enabled: true,
                                      mode: !this.state.tdosInverse
                                        ? 'x'
                                        : 'y'
                                    },
                                    pan: {
                                      // Boolean to enable panning
                                      enabled: true
                                    },
                                    annotation: {
                                      annotations: [
                                      {
                                        type: 'line',
                                        mode: !this.state.tdosInverse
                                          ? 'vertical'
                                          : 'horizontal',
                                        scaleID: !this.state.tdosInverse
                                          ? 'x-axis-0'
                                          : 'y-axis-0',
                                        value: '0',
                                        borderColor: 'red'
                                      }
                                      ]
                                    }
                                  }}/>
                                  <button onClick={this.downloadTdos.bind(this)} className="btn">download Tdos</button>
                                  <button onClick={this.downloadPdos.bind(this)} className="btn">download Pdos</button>
                                  <button onClick={this.exportPdos.bind(this)} className="btn">Export this graph</button>
                                  <button onClick={(
                                  ) => this.pdos
                                    ? this.pdos.chartInstance.resetZoom()
                                    : null} className="btn">Reset zoom</button>
                                  <button onClick={this.state.tdosInverse
                                    ? this.getPdos.bind(this)
                                    : this.getPdosInversed.bind(this)} className="btn">Inverse</button>

                                </div>
                                : <div className="col text-center">
                                  <p>The total DOS describes the number of states per interval of energy. It corresponds to the integration of the electronic band structure over the Brillouin zone. Atom-projected DOS (pDOS) give information on the relative contribution of each atom's electronic levels to the different bands around the Fermi level (reference zero energy).</p>
                                  <button className="btn btn-primary" onClick={this.getPdos.bind(this)}>Get pdos</button>
                                </div>
                            }
                          </div>
                          : null
                      }
                    </div>
                  </Col>
                  : null
              }

              <Col className="col-6 mb-4">
                <div className="card h-100 mb-0">
                  <div className="card-header">
                    <Row>
                      <Col className="col-auto mr-auto"><h5 className="m-0">XRD Pattern</h5></Col>
                      <Col className="col-auto">
                        <a className="text-muted" onClick={() => this.setState({
                          openedXrd: !this.state.openedXrd
                        })}>
                          {
                            this.state.openedXrd
                              ? <MinusIcon/>
                              : <PlusIcon/>
                          }
                        </a>
                      </Col>
                    </Row>
                  </div>
                  {
                    this.state.openedXrd
                      ? <div className="card-body row align-items-center">
                        <div className="col">
                          {
                            this.state && this.state.xrd
                              ? <div>
                                <Line ref={(xrd) => {
                                  this.xrd = xrd;
                                }} data={this.state.xrd} options={{
                                  // maintainAspectRatio: false,
                                  legend: {
                                    display: false
                                  },
                                  elements: {
                                    line: {
                                      tension: 0, // disables bezier curves
                                    },
                                    point: {
                                      radius: 0,
                                      hitRadius: 10,
                                      hoverRadius: 4,
                                      hoverBorderWidth: 3
                                    }
                                  },
                                  scales: {
                                    xAxes: [
                                    {
                                      type: 'linear',
                                      ticks: {
                                        beginAtZero: true,
                                        fontSize: 14,
                                        fontStyle: 'bold'
                                      },
                                      scaleLabel: {
                                        display: true,
                                        labelString: '2 θ°',
                                        fontSize: 14,
                                        fontStyle: 'bold'
                                      }
                                    }
                                    ]
                                  },
                                  zoom: {
                                    enabled: true,
                                    mode: 'xy'
                                  },
                                  pan: {
                                    // Boolean to enable panning
                                    enabled: true
                                  }
                                }}></Line>
                                <button onClick={this.exportXRD.bind(this)} className="btn">Export this graph</button>
                              </div>
                              : <p className="text-center">Simulated X-ray diffraction pattern for the relaxed structure.</p>
                          }
                          <form className="mt-2 text-center" onSubmit={this.getXRD.bind(this)}>
                            Choose your own source: &nbsp;
                            <select className="custom-select" style={{
                                width: 'auto'
                            }} id="wavelength">
                              <option value="CuKa">CuKa</option>
                              <option value="CuKa2">CuKa2</option>
                              <option value="CuKa1">CuKa1</option>
                              <option value="CuKb1">CuKb1</option>
                              <option value="MoKa">MoKa</option>
                              <option value="MoKa2">MoKa2</option>
                              <option value="MoKa1">MoKa1</option>
                              <option value="MoKb1">MoKb1</option>
                              <option value="CrKa">CrKa</option>
                              <option value="CrKa2">CrKa2</option>
                              <option value="CrKa1">CrKa1</option>
                              <option value="CrKb1">CrKb1</option>
                              <option value="FeKa">FeKa</option>
                              <option value="FeKa2">FeKa2</option>
                              <option value="FeKa1">FeKa1</option>
                              <option value="FeKb1">FeKb1</option>
                              <option value="CoKa">CoKa</option>
                              <option value="CoKa2">CoKa2</option>
                              <option value="CoKa1">CoKa1</option>
                              <option value="CoKb1">CoKb1</option>
                              <option value="AgKa">AgKa</option>
                              <option value="AgKa2">AgKa2</option>
                              <option value="AgKa1">AgKa1</option>
                              <option value="AgKb1">AgKb1</option>
                            </select>
                            <button type="submit" className="btn btn-primary">Get xrd</button>
                          </form>
                        </div>
                      </div>
                      : null
                  }
                </div>
              </Col>
              {/*
                <Col className="col-12">
                <div className="card card-margin-bottom">
                <div className="card-header">
                <Row>
                <Col className="col-auto mr-auto">Supercell</Col>
                <Col className="col-auto"></Col>
                </Row>
                </div>
                <div className="card-body">
                <button className="btn" onClick={this.supercell.bind(this)}>Supercell</button>
                <ul>
                {structure.supercellStructures ? structure.supercellStructures.map((supercellId, index) => (
                <li key={index}><Link to={`/structures/${supercellId}`}>{supercellId}</Link></li>
                )) : null}
                </ul>
                </div>
                </div>
                </Col>
                */
              } {
                structure.bader && structure.bader.length
                  ? <Col className="col-6 mb-4">
                    <div className="card h-100 mb-0">
                      <div className="card-header">
                        <Row>
                          <Col className="col-auto mr-auto"><h5 className="m-0">Atomic charges</h5></Col>
                          <Col className="col-auto">
                            <a className="text-muted" onClick={() => this.setState({
                              openedBader: !this.state.openedBader
                            })}>
                              {
                                this.state.openedBader
                                  ? <MinusIcon/>
                                  : <PlusIcon/>
                              }
                            </a>
                          </Col>
                        </Row>
                      </div>
                      {
                        this.state.openedBader
                          ? <div className="card-body row align-items-center">
                            {
                              this.state.bader
                                ? <table className="table table-sm text-right align-self-start">
                                  <thead className="thead-light">
                                    <tr>
                                      <th className="text-center">Element</th>
                                      <th className="text-center">Wyckoff</th>
                                      <th className="text-center">Bader</th>

                                    </tr>
                                  </thead>
                                  <BaderLine structure={structure}/>
                                </table>
                                : <div className="col text-center">
                                  <p>The atomic charges are computed following the theory of Atoms In Molecules (AIM). Remember that atomic charges are not observable !</p>
                                  <button type="button" onClick={() => this.setState({bader: true})} className="btn btn-primary">Get bader</button>
                                </div>
                            }
                          </div>
                          : null
                      }
                    </div>
                  </Col>
                  : null
              } {
                structure.madelung && structure.madelung.energies
                  ? <Col className="col-6 mb-4">
                    <div className="card h-100 mb-0">
                      <div className="card-header">
                        <Row>
                          <Col className="col-auto mr-auto"><h5 className="m-0">Madelung Potentials and Constants</h5></Col>
                          <Col className="col-auto">
                            <a className="text-muted" onClick={() => this.setState({
                              openedMadelung: !this.state.openedMadelung
                            })}>
                              {
                                this.state.openedMadelung
                                  ? <MinusIcon/>
                                  : <PlusIcon/>
                              }
                            </a>
                          </Col>
                        </Row>
                      </div>
                      {
                        this.state.openedMadelung
                          ? <div className="card-body row align-items-center">

                            {
                              this.state.madelung
                                ? <div className="col align-self-start">
                                  <MadelungConstants structure={structure}/>
                                  {/*<table className="table table-sm text-right">
                                    <thead className="thead-light">
                                      <tr>
                                    <th className="text-center">Element</th>
                                    <th className="text-center">Min</th>
                                    <th className="text-center">Max</th>
                                    <th className="text-center">Moy</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {
                                    structure.madelung.energies.map((obj, index) => (<tr key={index}>
                                    <td className="text-center">{obj.element}</td>
                                    <td className="text-center">{Number(obj.min).toFixed(3)}</td>
                                    <td className="text-center">{Number(obj.max).toFixed(3)}</td>
                                    <td className="text-center">{Number(obj.moy).toFixed(3)}</td>
                                    </tr>))
                                      }
                                    </tbody>
                                  </table>*/}
                                  <p className="mb-0 row">
                                    <span className="col">
                                      <label className="text-muted">E_elec (eV) :</label>
                                      <b className="text-dark">{Number(structure.madelung.e_elec).toFixed(3)}</b><br/>
                                    </span>
                                    <span className="col">
                                      <label className="text-muted">E_elec/UF (eV) :</label>
                                      <b className="text-dark">{Number(structure.madelung['e_elec/UF']).toFixed(3)}</b>
                                    </span>
                                  </p>
                                </div>
                                : <div className="col text-center">
                                  <p>Madelung potentials on each Wickoff site using the atomic positions of the relaxed structure and the atomic Bader charges.</p>
                                  <button type="button" onClick={() => this.setState({madelung: true})} className="btn btn-primary">Get madelung</button>
                                </div>
                            }
                          </div>
                          : null
                      }
                    </div>
                  </Col>
                  : null
              } {
                structure.relaxedStructure
                  ? <Col className="col-12 mb-4">
                    <div className="card card-margin-bottom">
                      <div className="card-header">
                        <Row>
                          <Col className="col-auto mr-auto"><h5 className="m-0">Go beyond</h5></Col>
                          <Col className="col-auto">
                            <a className="text-muted" onClick={() => this.setState({
                              openedBeyong: !this.state.openedBeyong
                            })}>
                              {
                                this.state.openedBeyong
                                  ? <MinusIcon/>
                                  : <PlusIcon/>
                              }
                            </a>
                          </Col>
                        </Row>
                      </div>
                      {
                        this.state.openedBeyong
                          ? <div className="card-body">
                            <p>
                              <button className="btn btn-secondary btn-block">Test Précision</button>
                            </p>
                            <p>
                              <button className="btn btn-secondary btn-block">calcul diagramme de bande</button>
                            </p>
                            <p>
                              <button className="btn btn-secondary btn-block">Propriétés Élastiques</button>
                            </p>
                            <p>
                              <button className="btn btn-secondary btn-block">calcul énergie de site</button>
                            </p>
                            <p>
                              <button className="btn btn-secondary btn-block">substitution</button>
                            </p>
                            <p>
                              <button className="btn btn-secondary btn-block">calcul des fréquence de vibration (phonon)</button>
                            </p>
                            <p>
                              <button className="btn btn-secondary btn-block">calcul de COOP</button>
                            </p>
                            <p>
                              <button className="btn btn-secondary btn-block">FUKUI</button>
                            </p>
                            <p>
                              <button className="btn btn-secondary btn-block">ELF</button>
                            </p>
                            <p>
                              <button className="btn btn-secondary btn-block">diagrame de phase</button>
                            </p>
                            <p>
                              <button className="btn btn-secondary btn-block">Energie de décomposition</button>
                            </p>
                            <p>
                              <button className="btn btn-secondary btn-block">Spectro</button>
                            </p>
                          </div>
                          : null
                      }
                    </div>
                  </Col>
                  : null
              }</Row>
            <Modal isOpen={this.state.modal} className="modal-lg" toggle={this.toggle} backdrop={true}>
              <ModalHeader toggle={this.toggle}>Potential tutorial</ModalHeader>
              <ModalBody>
                <div className="embed-responsive embed-responsive-16by9">
                  <iframe title="top" className="embed-responsive-item" src="https://www.youtube.com/embed/p-MNSLsjjdo" allowfullscreen="allowfullscreen"></iframe>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={this.toggle}>Ok, I'm done !</Button>
              </ModalFooter>
            </Modal>
          </Container>
        </div>
      )
    } else {
      return null
    }
  }
}

const mapStateToProps = (state, ownProps) => ({
  structure: state.structures.byId[ownProps.match.params.structureId],
  project: state.projects.byId[ownProps.match.params.projectId],
  structureId: ownProps.match.params.structureId
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getStructureById
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Structure));



// WEBPACK FOOTER //
// ./src/containers/structures/results.js